export default `# AI Governance

The governance panel connects your session to Credo.ai for AI use case risk classification and compliance tracking. It ensures responsible AI use by mapping your work to governance frameworks.

---

## Risk Classification

The top card shows your use case's risk level:
- **Level 1** — Low risk
- **Level 2** — Medium risk
- **Level 3** — High risk

Each level includes:
- **Use Case ID** — The Credo.ai reference identifier
- **Risk label** — Human-readable classification
- **Risk description** — What this level means for your project

---

## Governance Stats

Three summary cards:
- **Surveys** — Number of governance questionnaires
- **Questions Answered** — Total Q&A responses completed
- **Last Synced** — When data was last pulled from Credo.ai

---

## Governance Surveys

Surveys from Credo.ai appear as collapsible sections. Each survey contains:
- **Survey name** and question count
- **Individual questions** with their answers displayed in a structured format

Expand any survey to review the full Q&A content.

---

## Syncing

Click **Sync with Credo.ai** to pull the latest risk classification and survey data. This ensures your governance information stays current as assessments are updated in Credo.ai.

---

## Tips

- **Sync early in the project** — Know your risk level before making key design decisions
- **Review survey answers with stakeholders** — Governance responses often surface compliance requirements that affect architecture
- **Higher risk levels** may require additional safeguards, documentation, or review processes`;
